import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="bg-white px-5 py-20 sm:py-24 lg:px-8" data-id="element-44" data-mp="3udf9v3lh1fkb">
      <Reveal className="mx-auto max-w-6xl" data-id="element-45" data-mp="c6itfq9y5v5k">
        <div className="relative isolate overflow-hidden rounded-3xl bg-brand-600 px-6 py-16 text-center sm:px-14 sm:py-20" data-id="element-46" data-mp="c7k4vvuvkjnt">
          <div aria-hidden="true" className="absolute inset-0 opacity-60 [background-image:radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.22),transparent_45%),radial-gradient(circle_at_85%_100%,rgba(6,13,61,0.5),transparent_50%)]" data-id="element-47" data-mp="87a20s2dq9d6" />
          <div className="relative" data-id="element-48" data-mp="vtgjs61lv3gl">
            <h2 className="mx-auto max-w-2xl text-[1.85rem] font-semibold leading-[1.12] tracking-[-0.02em] text-white sm:text-[2.5rem]" data-id="element-49" data-mp="vwks9fm3sld2">
              Tu próximo trade comienza con una decisión.
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-[15.5px] leading-relaxed text-white/80" data-id="element-50" data-mp="zwmwnwj83sw1">
              Conoce la plataforma y decide si Elyon Markets es adecuada para ti.
            </p>
            <div className="mt-9" data-id="element-51" data-mp="2h3rgah3b7de6">
              <CTAButton label="Abrir cuenta" location="final_cta" size="lg" variant="outline" className="w-full sm:w-auto" data-id="element-52" data-mp="2h4srqmo8m1wf" />
            </div>
            <p className="mx-auto mt-8 max-w-md text-[12px] leading-relaxed text-white/70" data-id="element-53" data-mp="2r38gwk3pf13a">
              Trading involves significant risk and may not be suitable for all
              investors.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}